import { erganiComparableValue } from "./erganiSlots";
import { canonicalSlotValue } from "./softoneSlotSync";

/** Ribbons compare a real slot. All three empty is just a blank cell. */
export function scheduleRibbonsVisible(internal, foxlineValue, erganiRow) {
  return Boolean(
    canonicalSlotValue(internal)
    || canonicalSlotValue(foxlineValue)
    || erganiComparableValue(erganiRow)
  );
}

/** Internal already holds the same value SoftOne has, so the cell is not a pending change. */
export function internalMatchesSoftone(internal, foxSlot) {
  const local = canonicalSlotValue(internal);
  const fox = canonicalSlotValue(foxSlot?.foxline);
  return Boolean(local) && local === fox;
}

/** What one schedule cell shows when the grid is switched off Internal. */
export function scheduleSourceCell(source, { internal, foxSlot, erganiRow, ready = true } = {}) {
  if (source !== "softone" && source !== "ergani") {
    return { active: false, value: "", differs: false, pending: false };
  }
  if (!ready) {
    return { active: true, value: "", differs: false, pending: true };
  }
  const value = source === "softone"
    ? canonicalSlotValue(foxSlot?.foxline)
    : erganiComparableValue(erganiRow);
  return {
    active: true,
    value,
    differs: canonicalSlotValue(internal) !== value,
    pending: false,
  };
}
